import { Component, OnInit, Input } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { ValidatedRadioButtonModel } from '../../../../../validations/validated-radio-button-group.component'
import { ValidatedTextField } from '../../../../../validations/validated-text-field.component'
import { NumericTextFieldValidator } from '../../../../../validations/numeric-text-field-validator'
import { ValidatedDateTextField } from '../../../../../validations/validated-date-text-field.component'
import { BeneficiaryInfo } from '../../../../models/enrollments'
import { NotBlankGenericFieldValidator } from '../../../../../validations/not-blank-generic-field-validator'
import { EnrollmentViewModel } from '../../../../models/enrollment-view-model'
import { AddressDB } from '../../../../../user-management/models/address'
import { ValidatedSelectOptionModel } from '../../../../../validations/validated-dropdown.component'
import { EmailAddressTextFieldValidator } from '../../../../../validations/email-address-text-field-validator'
import { LengthTextFieldValidator } from '../../../../../validations/length-text-field-validator'
import { DateTextFieldValidator } from '../../../../../validations/date-text-field.validator'
import { RequiredRadioButtonFieldValidator } from '../../../../../validations/required-radio-button-field-validator'
import { PortalGlobals } from '../../../../../portalglobals'
import { EnrollmentGateway } from '../../../../gateways/enrollment-gateway'
import { ValidatedSelectOptionModel as State } from '../../../../../validations/validated-dropdown.component'
import { LicenseApptGateway } from '../../../../../user-management/gateways/license-appt-gateway'
import { DispositionLookUP } from '.././.././../../../call-start/models/disposition-lookup'
import { CallLogLookUp } from '.././.././../../../call-start/models/call-log-lookup'
import { StateGateway } from '../../../../../common/gateways/state-gateway'
import { CurrentUserGateway } from '../../../../../common/gateways/current-user-gateway'
@Component({
    selector: 'BeneficiaryDetailsSpanish',
    templateUrl: 'beneficiarydetails.component.html'
})
export class BeneficiaryDetailsSpanishComponent implements OnInit {
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    notBlankValidator = new NotBlankGenericFieldValidator()
    public rblEmailPhoneReminder: ValidatedRadioButtonModel[] = []
    public rblPermissionToContact: ValidatedRadioButtonModel[] = []
    @Input() disabled: boolean = false
    validatedDate = new ValidatedDateTextField()
    genderOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    titleOptions: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    titleOption: string = ''
    genderOption: string = ''
    hasError: boolean
    ErrorMessages: any[]
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    public IsEmailPhoneReminderYes: boolean
    public IsEmailPhoneReminderNo: boolean
    public IsRdlHMOYes: boolean
    phoneNumber: string
    numericTextFieldValidator = new NumericTextFieldValidator()
    lengthValidator = new LengthTextFieldValidator(10)
    dateTextFieldValidator = new DateTextFieldValidator()
    requiredRadioButtonValidator = new RequiredRadioButtonFieldValidator()
    emailAddressTextFieldValidator = new EmailAddressTextFieldValidator()
    states: State[] = [] as State[]
    disposition: DispositionLookUP[]
    dispositionDropDown: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    dispositionDrop: ValidatedSelectOptionModel = {} as ValidatedSelectOptionModel
    callLogID: number
    callLogLookUp = {} as CallLogLookUp
    public sub: any
    secId: number
    Isdisplay: boolean
    DispositionId: number
    IsContentdisplay: boolean
    insuranceComapny: string
    extId: number
    qtipNote: string
    ShowCurrentYearScript: boolean = false

    CallerName: string = ''
    constructor(
        public _global: PortalGlobals,
        private router: Router,
        private _enrollementGateway: EnrollmentGateway,
        private _licenseAppGateway: LicenseApptGateway,
        private route: ActivatedRoute,
        private _currentUserGateway: CurrentUserGateway,
        private _stateGateway: StateGateway
    ) {
        this.rblEmailPhoneReminder.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblPermissionToContact.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.IsEmailPhoneReminderYes = false
        this.IsEmailPhoneReminderNo = false
        this.Isdisplay = true
        this.IsContentdisplay = false

        if (Number(this._global.selectedPlanYear) === this._global.PreviousPlanYear) {
            this.ShowCurrentYearScript = true
        } else {
            this.ShowCurrentYearScript = false
        }
    }
    ngOnInit() {
        if (this._global === undefined || this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user
                    this.insuranceComapny = this._global.currentUser.insuranceCompanyName
                }
            })
        }
        this.hasError = false
        this.qtipNote = 'qTip Note:'
        if (this._global.currentUser.insuranceCompanyName !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        sessionStorage.setItem('enrollmentViewModel', JSON.stringify(this.enrollment))
        if (this.enrollment !== undefined && this.enrollment.APPPHONE !== undefined) {
            this.phoneNumber = this.enrollment.APPPHONE
        }

        // if (Number(this._global.selectedPlanYear) === this._global.CurrentYear) {
        // this.ShowCurrentYearScript = true
        //}

        this.route.params.subscribe((params) => {
            this.secId = +params['secID']
            if (this.secId == 6) {
                this.Isdisplay = false
                this.IsContentdisplay = true
            }
            // this.extId = +params['extId']
            // if (this.secId == 6 && this.extId == 1) {
            //    this.qtipNote = 'Note:'
            // }
            // else {
            //    this.qtipNote = 'qTip Note:'
            // }
        })

        this._stateGateway.getAllStates().subscribe((state: State[]) => {
            this.states = state
        })

        this.titleOptions = [
            { value: 'MR', text: 'MR' },
            { value: 'MRS', text: 'MRS' },
            { value: 'DR', text: 'DR' },
            { value: 'MS', text: 'MS' }
        ]

        this.genderOptions = [
            { value: 'M', htmlLabel: 'M', disabled: this.disabled },
            { value: 'F', htmlLabel: 'F', disabled: this.disabled }
        ]

        // TODO: Code-Review: We already have one call above, need to remove another below call
        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()

        if (this.enrollmentViewModel !== undefined && this.enrollmentViewModel.APPFN !== '' && this.enrollmentViewModel.APPFN !== null) {
            this.CallerName = this.enrollmentViewModel.APPFN + ', '
        }

        this._enrollementGateway.getDispositionByPlanYear(this._global.selectedPlanYear.toString()).subscribe((data: DispositionLookUP[]) => {
            this.disposition = data
            for (let i = 0; i < this.disposition.length; i++) {
                this.dispositionDrop.value = this.disposition[i].DispositionLookupId
                this.dispositionDrop.text = this.disposition[i].Disposition
                this.dispositionDropDown.push(this.dispositionDrop)
                this.dispositionDrop = {} as ValidatedSelectOptionModel
            }
        })
    }
    Continue() {
        this.IsContentdisplay = true
    }
    EndCall() {
        this.callLogLookUp.CallLogID = this.enrollmentViewModel.CALLOGID
        this.callLogLookUp.FirstName = this.enrollmentViewModel.APPFN
        this.callLogLookUp.LastName = this.enrollmentViewModel.APPLN
        this.callLogLookUp.DateOfBirth = this.enrollmentViewModel.APPDOB
        this.callLogLookUp.Gender = this.enrollmentViewModel.APPGEN
        this.callLogLookUp.PhoneNumber = this.enrollmentViewModel.AUTHREPPHONE
        this.callLogLookUp.Title = this.enrollmentViewModel.TITLE
        this.callLogLookUp.StreetAddress = this.enrollmentViewModel.APPADD1 + ' ' + this.enrollmentViewModel.APPADD2
        this.callLogLookUp.City = this.enrollmentViewModel.APPCITY
        this.callLogLookUp.StateAbbreviation = this.enrollmentViewModel.APPST
        this.callLogLookUp.Zipcode = this.enrollmentViewModel.APPZIP
        this.callLogLookUp.Email = this.enrollmentViewModel.APPEMAIL
        if (this.callLogLookUp !== undefined) {
            // TODO: Code-Review: We can call these 2 methods in to single API call to save the data, need to change it
            this._enrollementGateway.SaveCallLogClientLookup(this.callLogLookUp).subscribe((data: number) => {
                this._enrollementGateway
                    .SaveCallErollmentLog(
                        this.enrollmentViewModel.CALLOGID,
                        this.enrollmentViewModel.CALLENROLLMENTSTARTTIME,
                        this.DispositionId,
                        parseInt(this.enrollmentViewModel.IsBeneficiary) || 0
                    )
                    .subscribe((data: number) => {
                        // this.router.navigate([''])
                        window.close()
                    })
            })
        }
    }
    ShowGroupOptionsPhoneReminder(isgroup: string) {
        if (isgroup === 'Yes') {
            this.IsEmailPhoneReminderYes = true
            this.IsEmailPhoneReminderNo = false
        }
        if (isgroup === 'No') {
            this.IsEmailPhoneReminderYes = false
            this.IsEmailPhoneReminderNo = true
        }
    }
    ShowGroupOptionsPermissionToContact(isgroup: string) {
        if (isgroup === 'Yes') {
            this.IsEmailPhoneReminderNo = true
        }
        if (isgroup === 'No') {
            this.IsEmailPhoneReminderNo = true
        }
    }
}
